import axios from "axios";
import { API_BASE, ENDPOINTS } from "./config";

const client = axios.create({ baseURL: API_BASE, timeout: 20000 });

// Tiny in-memory cache so Navbar, Footer and pages share one request.
const cache = new Map();
const TTL = 45 * 1000;

export function cachedGet(path) {
  const hit = cache.get(path);
  const now = Date.now();
  if (hit && now - hit.at < TTL) return hit.promise;
  const promise = client.get(path).then((r) => r.data);
  cache.set(path, { at: now, promise });
  promise.catch(() => cache.delete(path));
  return promise;
}

// Optional endpoints (Starline / Jackpot): a missing endpoint is not an error, it resolves to null.
const optional = (path) => cachedGet(path).catch(() => null);

export const getMarkets = () => cachedGet("/api/marketManagement/getMarketGames");
export const getResults = () => cachedGet("/api/mainmarketdeclareResult/getDeclareResult");
export const getRates = () => cachedGet("/api/rates/getBetRatesWeb");
export const getContact = () => cachedGet("/api/settings/general/whatsapp");

export const getStarlineGames = () => optional(ENDPOINTS.starlineGames);
export const getStarlineResults = () => optional(ENDPOINTS.starlineResults);
export const getJackpotGames = () => optional(ENDPOINTS.jackpotGames);
export const getJackpotResults = () => optional(ENDPOINTS.jackpotResults);
